import { render, staticRenderFns } from "./TabCustomer.vue?vue&type=template&id=f0aa7fdc&scoped=true&"
import script from "./TabCustomer.vue?vue&type=script&lang=js&"
export * from "./TabCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TabCustomer.vue?vue&type=style&index=0&id=f0aa7fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0aa7fdc",
  null
  
)

export default component.exports